import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { OfbizForm, OfbizList } from '@urbannex/ofbiz-forms';
import { LookUpDialogService } from '../lookup-dialog-container/look-up-dialog.service';
import { ComponentConfig, Relation, SelectedValue } from '../shared/model';
import { UbsComponentStoreService } from '../ubs-component-store.service';
import { RelationService } from './relation.service';
import { Subject, takeUntil } from 'rxjs';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'ubs-relation-container',
  templateUrl: './relation-container.component.html',
  styleUrls: ['./relation-container.component.scss'],
})
export class RelationContainerComponent implements OnInit,OnDestroy {
  @Input() relation:Relation;
  @Input() relations:any[];
  @Input () selectedValue: SelectedValue;
  appContext:string;
  addForm:OfbizForm;
  listForm:OfbizList;
  parameters:any;
  addContainerTitle:string;
  listContainerTitle:string;
  title:string;
  lookupFieldResult:any;
  noList = false;

  private destroy$ = new Subject<void>()

 
  constructor(
    private componentStore:UbsComponentStoreService,
    private lookUpDialogService:LookUpDialogService,
    private relationService:RelationService,
    private route: ActivatedRoute) { }
  
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(): void {
    this.componentStore.selectedRelation$.subscribe((relation:Relation) => {
      this.relation = relation;
      this.addForm = this.relation.addForm;
      if(relation.listForm != undefined){
        this.listForm = this.relation.listForm;
      }else{
        this.noList = true;
      }
      this.addContainerTitle = this.relation.addContainerTitle;
      this.listContainerTitle = this.relation.listContainerTitle;
      console.log({"SelectedValue":this.selectedValue});
      console.log({"IncomingRelation":this.relation});
      //this.componentStore.vm$.pipe(takeUntil(this.destroy$)).subscribe(state => {console.log("SelectedValue in subscription",state.selectedValue)})
      this.componentStore.selectedValue$.subscribe((selectedValue:SelectedValue) => {
        this.selectedValue = selectedValue;
        console.log({"IncomingRelation":this.selectedValue});
        if(selectedValue != null && selectedValue != undefined){
          if(selectedValue.data != undefined && selectedValue.data.parameters != undefined){
            this.parameters = selectedValue.data.parameters;
            //if route has parameters, populate this parameters
            if(this.parameters != undefined){
              this.populateParametersFromRoute()
            }
          }
          if(selectedValue.label != undefined){
            this.addContainerTitle = this.addContainerTitle+" "+selectedValue.label;
            this.listContainerTitle = this.listContainerTitle+" "+selectedValue.label;
          }
        }else if(selectedValue == undefined || selectedValue == null){
          this.title = this.relation.addContainerTitle;
          this.addContainerTitle = this.relation.addContainerTitle;
          console.log(this.title,this.addContainerTitle);
          console.log(this.addForm.breadCrumbData)
          let remoteFormData = this.addForm.breadCrumbData["data"];
          let formData = remoteFormData["formData"];
          let endPoint = remoteFormData["endPoint"];
          let parameters = remoteFormData["parameters"];
          this.parameters = parameters;
          //if route has parameters, populate this parameters
          if(this.parameters != undefined){
            this.populateParametersFromRoute()
          }
          
          this.selectedValue = {
            type:"",
            data:{
              formData:formData,
              parameters:parameters,
              endPoint:endPoint?endPoint:null
            }
          }
          console.log(this.selectedValue);
        }
        
        
        
      });
    });
    
    this.lookUpDialogService.getLookupSelectedValue().subscribe(data => {
      console.log({TrackDialog:data});
      this.lookupFieldResult = data;
    });
    this.componentStore.componentConfig$.subscribe((componentConfig:ComponentConfig) => {
      this.appContext = componentConfig.appContext;
    })
    
  }

  refreshRelatedLists(e){
    console.log({RefreshList:e,Component:"RelationContainerComponent",Comment:"Setting refreshList via relationService"})
    if(e == "success"){
      this.relationService.setRefreshList(true);
    }else{
      this.relationService.setRefreshList(false);
    }
    
  }

  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    if(changes["relations"]){
      console.log({TrackRelations:this.relations});
      
    }
  }
  populateParametersFromRoute(){
    this.route.paramMap.subscribe((params) => {
      const paramObj: { [key: string]: string } = {};
      params.keys.forEach((key) => {
        if(this.parameters[key] != null && this.parameters[key] != undefined){
          this.parameters[key] = params.get(key);
        }
        //paramObj[key] = params.get(key) as string;
      });
      console.log('Route Parameters:', paramObj,this.parameters);

    });
  }

}
